/** "1,905g 39s 90c"; `short` gives whole gold only: "1,905g". */
export function formatMoney(copper: number, short = false): string {
  const sign = copper < 0 ? '−' : '';
  const abs = Math.abs(Math.round(copper));
  const g = Math.floor(abs / 10_000);
  const s = Math.floor((abs % 10_000) / 100);
  const c = abs % 100;
  if (short) return `${sign}${g.toLocaleString('en-GB')}g`;
  const parts = [g ? `${g.toLocaleString('en-GB')}g` : '', g || s ? `${s}s` : '', `${c}c`];
  return sign + parts.filter(Boolean).join(' ');
}
